import { baseSeriesMark } from "../base/constant";

export const mapSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    area: {
        name: "area",
        type: "path"
    }
});
//# sourceMappingURL=constant.js.map
